
import { defineComponent, watch, reactive, onMounted, onUnmounted, PropType } from 'vue'
import { store } from '@/store'
import { getLiveProgress } from '@/api/tripply/live'
import { RouteLiveState } from '@/api/tripply/models'

export default defineComponent({
  name: 'LiveTimer',
  props: {
    liveState: {
      type: Object as PropType<RouteLiveState>,
      required: true
    },
  },
  setup(props) {
    let timer: NodeJS.Timeout
    const state = reactive({
      loading: true,
      ratio: 1,
      overtime: false,
      break: false,
      clock: '00:00'
    })

    async function calculateTime() {
      state.loading = false
      const liveProgress = await getLiveProgress(props.liveState)
      state.break = liveProgress.hasBreak
      state.overtime = liveProgress.overtime
      state.ratio = liveProgress.ratio
      state.clock = liveProgress.clock
    }

    watch(() => props.liveState, () => {
      calculateTime()
    })

    onMounted(() => {
      timer = setInterval(() => {
        calculateTime()
      }, 1000)
    })

    onUnmounted(() => {
      clearInterval(timer)
    })

    return { state }
  }
})
